import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import type { BlogTranscribingStatusEnum } from './BlogTranscribingStatusEnum'

@ObjectType()
@InputType('BlogTranscribingMetadataInput')
export class BlogTranscribingMetadata {
  @Field(() => String)
  @Prop({ type: String })
  status: BlogTranscribingStatusEnum

  @Field(() => String)
  @Prop({ type: String })
  jobId: string

  @Field(() => Date)
  @Prop({ type: Date })
  startedAt: Date

  @Field(() => Number)
  @Prop({ type: Number })
  videoCount: number
}
